export default __webpack_public_path__ + "static/media/card.f6827960.png";